import lazyLoadView from "./lazyload-view";
import routeError from "./route-error";
import store from '@store'
import { FAKE_RESOURCEITEM } from "../config/fake-resource";

export default [
  // ===
  // 微軟原⽣解決⽅案
  // ===
  {
    path: '/product/brand/microsoft/solutionhub/resource',
    name: 'resource-list',
    component: () => lazyLoadView(import('@views/Resource/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const optionList = await store.dispatch('option/fetchOptionList', {
            types: 'resource',
            useCached: true
          })
          routeTo.params.optionList = optionList;
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      title: '微軟原⽣解決⽅案'
    },
    props: (route) => ({
      optionList: route.params.optionList
    })
  },
  {
    path: '/product/brand/microsoft/solutionhub/resource/:alias',
    name: 'resource-item',
    component: () => lazyLoadView(import('@views/Resource/Item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const defaultValue = await store.dispatch('article/fetchItem', {
            contentType: 'resource',
            alias: routeTo.params.alias
          })
          routeTo.params.defaultValue = defaultValue.items;
          routeTo.params.breadcrumbTitle =defaultValue.items.title;
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      title: '微軟原⽣解決⽅案-內容頁'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue || {},
    })
  },
]